import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  currentNav: { data: [], list: [], loading: false },
  publishedTree: { data: [], list: [], loading: false },
  versionTree: { data: [], list: [], loading: false },
  categoryTree: { data: [], loading: false },
  labelList: { data: [], loading: false },
  versionList: { data: [], loading: false },
  previewList: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  entityTypes: { data: [], loading: false },
  dialog: { visible: false, loading: false, type: '', data: null },
  nodeSort: { id: null, loading: false },
  versionExpand: false,
  nodeSaving: false,
  configSaving: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
